import { Table } from 'react-bootstrap';
import { SpaceWithOwner } from './GroupBookingsList';

/**
 * Travel Insurance Row
 */
export function TravelInsuranceRow({ space }: { space: SpaceWithOwner }) {
  const guestName = space.guest.givenName
    ? `${space.guest.givenName} ${space.guest.familyName}`
    : undefined;
  const ownerName = `${space.owner.givenName} ${space.owner.familyName}`;

  if (!space.guest.tripForm?.travelInsurance) {
    return (
      <tr>
        <td>{guestName || <i>Booked by {ownerName}</i>}</td>
        <td colSpan={3} className="text-muted">
          <i>Not completed</i>
        </td>
      </tr>
    );
  }

  return (
    <tr>
      <td>{guestName || <i>Booked by {ownerName}</i>}</td>
      <td>{space.guest.tripForm.travelInsurance.company}</td>
      <td>{space.guest.tripForm.travelInsurance.policyNumber}</td>
      <td>
        <a href={`tel:${space.guest.tripForm.travelInsurance.phone}`}>
          {space.guest.tripForm.travelInsurance.phone}
        </a>
      </td>
    </tr>
  );
}

/**
 * Travel Insurance Table
 */
export default function TravelInsuranceTable({
  spaces,
}: {
  spaces: SpaceWithOwner[];
}) {
  return (
    <Table striped bordered responsive>
      <thead>
        <tr>
          <th>Name</th>
          <th>Company</th>
          <th>Policy Number</th>
          <th>Phone</th>
        </tr>
      </thead>
      <tbody>
        {spaces.map((space) => (
          <TravelInsuranceRow space={space} key={space.id} />
        ))}
      </tbody>
    </Table>
  );
}
